import {colors} from 'shells/colors/colors';
import {ArchiveRegularIcon} from 'shells/icon/svg/archive-regular-icon';
import {EnvelopeRegularIcon} from 'shells/icon/svg/envelope-regular-icon';

import type {
    ToastNotificationProps,
    ToastNotificationVariant,
} from '../../client_modules/shells/react/components/toast-notification/toast-notification';
import type {NotificationIcon} from '../../notifications/index';

import type {NotificationObj} from './notification';

const mapLegacyToVariantAndIcon = (
    icon: NotificationIcon | undefined,
    variant: ToastNotificationVariant | undefined,
    customIcon: React.ReactNode | undefined
): Pick<ToastNotificationProps, 'variant' | 'customIcon'> => {
    if (variant || customIcon) {
        return {variant: variant || 'neutral', customIcon: customIcon || undefined};
    }

    if (!icon) {
        return {variant: 'neutral'};
    }

    switch (icon) {
        case 'check':
            return {variant: 'success'};
        case 'frowny':
            return {variant: 'error'};
        case 'email':
            return {
                variant: 'neutral',
                customIcon: <EnvelopeRegularIcon size={24} color={colors.grey} />,
            };
        case 'archive':
            return {
                variant: 'neutral',
                customIcon: <ArchiveRegularIcon size={24} color={colors.grey} />,
            };
    }
};

export const mapProps = (
    notification: NotificationObj,
    onNotificationClose: (notification: NotificationObj) => void
): ToastNotificationProps => {
    return {
        title: notification.title,
        subtitle: notification.options.body,
        primaryAction: notification.options.onClick
            ? {
                  label: notification.options.primaryActionLabel || 'View',
                  onClick: (e: React.SyntheticEvent<HTMLElement>) => {
                      notification.options.onClick?.(e);
                  },
              }
            : undefined,
        dismissAction: {
            label: notification.options.dismissActionLabel,
            onDismiss: () => {
                onNotificationClose(notification);
            },
        },
        ...mapLegacyToVariantAndIcon(
            notification.options.icon,
            notification.options.variant,
            notification.options.customIcon
        ),
    };
};
